const post = async (url, payload, timeoutMs = 20000) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });

    const contentType = response.headers.get("content-type") || "";
    const data = contentType.includes("application/json")
      ? await response.json().catch(() => null)
      : await response.text().catch(() => null);
      
    return { ok: response.ok, status: response.status, data };
  } catch (error) {
    const errorMessage = error?.message || "Network error";
    return { ok: false, status: 0, data: { error: errorMessage } };
  } finally {
    clearTimeout(timeoutId);
  }
};

const API_BASE_URL =
  process.env.REACT_APP_ENVIRONMENT === "dev"
    ? `${process.env.REACT_APP_WEALTH_ELITE_DEV}/eliteN/chat-bot`
    : process.env.REACT_APP_ENVIRONMENT === "live"
    ? `${process.env.REACT_APP_WEALTH_ELITE_LIVE}/eliteN/chat-bot`
    : `${process.env.REACT_APP_WEALTH_ELITE_LOCAL}/eliteN/chat-bot`;


export const apiBotMessage = (payload) => post(`${API_BASE_URL}/bot_message`, payload);
export const apiClient = (payload) => post(`${API_BASE_URL}/client`, payload);
export const apiProblemType = (payload) => post(`${API_BASE_URL}/problem_type`, payload);
export const apiRTA = (payload) => post(`${API_BASE_URL}/rta`, payload);
export const apiStoreArn = (payload) => post(`${API_BASE_URL}/store_arn`, payload);
export const apiInsertMessage = (payload) => post(`${API_BASE_URL}/insert_message`, payload);
export const apiInvestmentDate = (payload) => post(`${API_BASE_URL}/investment_date`, payload);
export const apiFileCall = (payload) => post(`${API_BASE_URL}/file_call`, payload);
export const apiFolio = (payload) => post(`${API_BASE_URL}/folio`, payload);
export const chatClose = (payload) => post(`${API_BASE_URL}/chat_close`, payload);


export const getAiAgentApiUrl = () => {
  switch (process.env.REACT_APP_AI_AGENT_ENVIRONMENT) {
    case "dev":
      return process.env.REACT_APP_AI_AGENT_DEV_URL;
    case "local":
      return process.env.REACT_APP_AI_AGENT_LOCAL_URL;
    default:
      return process.env.REACT_APP_AI_AGENT_LIVE_URL;
  }
};
